module.exports = __webpack_public_path__ + "static/img/0547_2.453babe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_2.jpg
// module id = OmPQ
// module chunks = 1